module.exports = __webpack_public_path__ + "img/2S.cfba06b7.png";